/**
 * BHG Labs identity helper.
 *
 * Renderers that can show any vendor call isBhgLabs() when a BHG Labs row needs different
 * treatment, for example showing the store's own product names instead of compound names.
 */
export const BHG_LABS_SLUG = "bhg-labs";

type VendorLike = { slug?: string | null; name?: string | null } | null | undefined;

export function isBhgLabs(vendor: VendorLike): boolean {
  if (!vendor) return false;
  if (vendor.slug === BHG_LABS_SLUG) return true;
  return (vendor.name || "").trim().toLowerCase() === "bhg labs";
}
